import { ExportStatus } from './common.js';

export const Kind = 'EXPORT_PREREGISTRATION_ENCOUNTER' as const;
export { ExportStatus as Status };
